module.exports = __webpack_public_path__ + "img/motorway_2x1.f31b2b71.svg";